module.exports = __webpack_public_path__ + "img/medal0.3ce1ac29.png";